import '../stylesheets/main.scss'
import '../images/backgrounds/city.jpg'
import '../images/backgrounds/team.jpg'
import '../images/backgrounds/mission-deco.jpg'
import MobileMenu from './navigation'
import SmoothScroll from 'smooth-scroll'

window.addEventListener('DOMContentLoaded', () => {

	new MobileMenu();

	new SmoothScroll('a[href*="#"]', {
		header: '#header',
		speed: 1000,
	})

	const header = document.getElementById('header')
	window.addEventListener('scroll', e => {
		if(window.scrollY > 0) header.classList.add('sticky')
		else header.classList.remove('sticky')
	})

})
